import React, { useState } from 'react';
import { Card, CardBody, Button, Input, Textarea, Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Chip, Tabs, Tab, Avatar, Select, SelectItem } from '@nextui-org/react';
import HeaderComponent from '../components/General/HeaderComponent';
import { FiPlus, FiSearch, FiInstagram, FiLinkedin, FiFacebook, FiEdit2, FiTrash2, FiCalendar, FiImage, FiFile } from 'react-icons/fi';
import { Notify } from 'notiflix';

export default function SocialMedia() {
  const [activeTab, setActiveTab] = useState('accounts');
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [isAccountModalOpen, setIsAccountModalOpen] = useState(false);
  const [isPostModalOpen, setIsPostModalOpen] = useState(false);
  const [isEditPostModalOpen, setIsEditPostModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedAccountForPost, setSelectedAccountForPost] = useState(null);
  const [editingPost, setEditingPost] = useState(null);

  // Dummy veriler - Sosyal medya hesapları
  const [accounts, setAccounts] = useState([
    {
      id: 1,
      platform: 'instagram',
      platformName: 'Instagram',
      username: 'heypena_official',
      accessToken: 'xxx',
      isConnected: true,
      followers: 12500,
      postsCount: 245
    },
    {
      id: 2,
      platform: 'linkedin',
      platformName: 'LinkedIn',
      username: 'HeyPena',
      accessToken: 'xxx',
      isConnected: true,
      followers: 8500,
      postsCount: 89
    },
    {
      id: 3,
      platform: 'facebook',
      platformName: 'Facebook',
      username: 'HeyPena Page',
      accessToken: 'xxx',
      isConnected: true,
      followers: 15600,
      postsCount: 312
    }
  ]);

  // Dummy veriler - Planlanmış içerikler
  const [scheduledPosts, setScheduledPosts] = useState([
    {
      id: 1,
      accountId: 1,
      accountName: 'heypena_official',
      platform: 'instagram',
      content: 'Yeni özelliklerimizi keşfedin! 🚀 #HeyPena #Productivity',
      media: 'image',
      scheduledDate: '2024-01-20 14:00',
      status: 'scheduled'
    },
    {
      id: 2,
      accountId: 2,
      accountName: 'HeyPena',
      platform: 'linkedin',
      content: 'Ekibimizle birlikte büyüyoruz! Kariyer fırsatlarımızı inceleyin.',
      media: 'none',
      scheduledDate: '2024-01-21 10:00',
      status: 'scheduled'
    },
    {
      id: 3,
      accountId: 1,
      accountName: 'heypena_official',
      platform: 'instagram',
      content: 'İş hayatınızı kolaylaştıran çözümler.',
      media: 'image',
      scheduledDate: '2024-01-19 16:00',
      status: 'published'
    }
  ]);

  const [accountForm, setAccountForm] = useState({
    platform: '',
    username: '',
    accessToken: ''
  });

  const [postForm, setPostForm] = useState({
    accountId: '',
    content: '',
    scheduledDate: '',
    media: 'none'
  });

  const platformOptions = [
    { value: 'instagram', label: 'Instagram', icon: FiInstagram },
    { value: 'linkedin', label: 'LinkedIn', icon: FiLinkedin },
    { value: 'facebook', label: 'Facebook', icon: FiFacebook }
  ];

  const getPlatformIcon = (platform) => {
    const option = platformOptions.find(p => p.value === platform);
    return option ? option.icon : FiInstagram;
  };

  const getPlatformColor = (platform) => {
    const colors = {
      instagram: 'text-pink-600 dark:text-pink-400',
      linkedin: 'text-blue-600 dark:text-blue-400',
      facebook: 'text-blue-700 dark:text-blue-500'
    };
    return colors[platform] || 'text-gray-600';
  };

  const handleAddAccount = () => {
    setAccountForm({ platform: '', username: '', accessToken: '' });
    setIsAccountModalOpen(true);
  };

  const handleSaveAccount = () => {
    if (!accountForm.platform || !accountForm.username || !accountForm.accessToken) {
      Notify.warning('Lütfen tüm alanları doldurun');
      return;
    }

    const platform = platformOptions.find(p => p.value === accountForm.platform);
    const newAccount = {
      id: accounts.length + 1,
      platform: accountForm.platform,
      platformName: platform?.label || accountForm.platform,
      username: accountForm.username,
      accessToken: accountForm.accessToken,
      isConnected: true,
      followers: 0,
      postsCount: 0
    };

    setAccounts([...accounts, newAccount]);
    setIsAccountModalOpen(false);
    setAccountForm({ platform: '', username: '', accessToken: '' });
    Notify.success('Hesap başarıyla eklendi!');
  };

  const handleDeleteAccount = (accountId) => {
    setAccounts(accounts.filter(acc => acc.id !== accountId));
    setScheduledPosts(scheduledPosts.filter(post => post.accountId !== accountId));
    Notify.success('Hesap silindi');
  };

  const handleCreatePost = () => {
    if (accounts.length === 0) {
      Notify.warning('Önce bir hesap eklemeniz gerekiyor');
      return;
    }
    setPostForm({ accountId: '', content: '', scheduledDate: '', media: 'none' });
    setSelectedAccountForPost(null);
    setIsPostModalOpen(true);
  };

  const handleSavePost = () => {
    if (!postForm.accountId || !postForm.content || !postForm.scheduledDate) {
      Notify.warning('Lütfen tüm alanları doldurun');
      return;
    }

    const account = accounts.find(acc => acc.id === parseInt(postForm.accountId));
    if (!account) return;

    const newPost = {
      id: scheduledPosts.length + 1,
      accountId: parseInt(postForm.accountId),
      accountName: account.username,
      platform: account.platform,
      content: postForm.content,
      media: postForm.media,
      scheduledDate: postForm.scheduledDate,
      status: 'scheduled'
    };

    setScheduledPosts([...scheduledPosts, newPost]);
    setIsPostModalOpen(false);
    setPostForm({ accountId: '', content: '', scheduledDate: '', media: 'none' });
    Notify.success('İçerik planlandı!');
  };

  const handleEditPost = (post) => {
    setEditingPost(post);
    setPostForm({
      accountId: post.accountId.toString(),
      content: post.content,
      scheduledDate: post.scheduledDate,
      media: post.media
    });
    setIsEditPostModalOpen(true);
  };

  const handleUpdatePost = () => {
    if (!postForm.accountId || !postForm.content || !postForm.scheduledDate) {
      Notify.warning('Lütfen tüm alanları doldurun');
      return;
    }

    setScheduledPosts(scheduledPosts.map(post =>
      post.id === editingPost.id
        ? { ...post, ...postForm, accountId: parseInt(postForm.accountId) }
        : post
    ));
    setIsEditPostModalOpen(false);
    setEditingPost(null);
    setPostForm({ accountId: '', content: '', scheduledDate: '', media: 'none' });
    Notify.success('İçerik güncellendi!');
  };

  const handleDeletePost = (postId) => {
    setScheduledPosts(scheduledPosts.filter(post => post.id !== postId));
    Notify.success('İçerik silindi');
  };

  const filteredAccounts = accounts.filter(acc =>
    acc.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
    acc.platformName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredPosts = scheduledPosts.filter(post =>
    post.content.toLowerCase().includes(searchTerm.toLowerCase()) ||
    post.accountName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="w-full dark:bg-dark-100 bg-gray-50 min-h-screen">
      <div className="container mx-auto px-4 py-6">
        <HeaderComponent title="Sosyal Medya Yönetimi" />

        <Tabs
          selectedKey={activeTab}
          onSelectionChange={setActiveTab}
          className="mt-6"
          classNames={{
            tabList: "bg-white dark:bg-dark-300 border border-gray-200 dark:border-dark-400 shadow-none",
            tab: "data-[selected=true]:bg-blue-50 dark:data-[selected=true]:bg-blue-900/20 data-[selected=true]:text-blue-600 dark:data-[selected=true]:text-blue-400",
            cursor: "bg-blue-100 dark:bg-blue-900/30"
          }}
        >
          <Tab key="accounts" title="Hesaplar" />
          <Tab key="content" title="İçerik Yönetimi" />
        </Tabs>

        <div className="mt-6">
          {/* Hesaplar Sekmesi */}
          {activeTab === 'accounts' && (
            <div className="space-y-4">
              <div className="flex justify-between items-center">
                <Input
                  placeholder="Hesap ara..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  startContent={<FiSearch className="text-gray-400" />}
                  className="max-w-xs"
                  classNames={{
                    input: "border border-gray-200 dark:border-dark-400",
                    inputWrapper: "border border-gray-200 dark:border-dark-400"
                  }}
                />
                <Button
                  className="bg-blue-600 hover:bg-blue-700 text-white"
                  startContent={<FiPlus className="w-4 h-4" />}
                  onPress={handleAddAccount}
                >
                  Hesap Ekle
                </Button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {filteredAccounts.map((account) => {
                  const IconComponent = getPlatformIcon(account.platform);
                  return (
                    <Card key={account.id} className="border border-gray-200 dark:border-dark-300 bg-white dark:bg-dark-300 shadow-none">
                      <CardBody className="p-5">
                        <div className="flex items-start justify-between mb-4">
                          <div className="flex items-center gap-3">
                            <div className={`p-2 rounded-lg bg-gray-100 dark:bg-gray-800 ${getPlatformColor(account.platform)}`}>
                              <IconComponent className="w-6 h-6" />
                            </div>
                            <div>
                              <h3 className="font-semibold text-[#283252] dark:text-darkWhite-300">{account.platformName}</h3>
                              <p className="text-sm text-gray-600 dark:text-gray-400">@{account.username}</p>
                            </div>
                          </div>
                          <Chip
                            size="sm"
                            variant="flat"
                            className={account.isConnected ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300' : 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300'}
                          >
                            {account.isConnected ? 'Bağlı' : 'Bağlı Değil'}
                          </Chip>
                        </div>
                        <div className="grid grid-cols-2 gap-4 mb-4">
                          <div>
                            <p className="text-xs text-gray-500 dark:text-gray-400">Takipçi</p>
                            <p className="text-lg font-semibold text-[#283252] dark:text-darkWhite-300">
                              {account.followers.toLocaleString('tr-TR')}
                            </p>
                          </div>
                          <div>
                            <p className="text-xs text-gray-500 dark:text-gray-400">Paylaşım</p>
                            <p className="text-lg font-semibold text-[#283252] dark:text-darkWhite-300">
                              {account.postsCount}
                            </p>
                          </div>
                        </div>
                        <div className="flex gap-2">
                          <Button
                            size="sm"
                            variant="light"
                            className="flex-1"
                            startContent={<FiTrash2 className="w-4 h-4" />}
                            onPress={() => handleDeleteAccount(account.id)}
                          >
                            Sil
                          </Button>
                        </div>
                      </CardBody>
                    </Card>
                  );
                })}
              </div>
            </div>
          )}

          {/* İçerik Yönetimi Sekmesi */}
          {activeTab === 'content' && (
            <div className="space-y-4">
              <div className="flex justify-between items-center">
                <Input
                  placeholder="İçerik ara..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  startContent={<FiSearch className="text-gray-400" />}
                  className="max-w-xs"
                  classNames={{
                    input: "border border-gray-200 dark:border-dark-400",
                    inputWrapper: "border border-gray-200 dark:border-dark-400"
                  }}
                />
                <Button
                  className="bg-blue-600 hover:bg-blue-700 text-white"
                  startContent={<FiPlus className="w-4 h-4" />}
                  onPress={handleCreatePost}
                >
                  Yeni İçerik
                </Button>
              </div>

              <Card className="border border-gray-200 dark:border-dark-300 bg-white dark:bg-dark-300 shadow-none">
                <CardBody className="p-0">
                  <div className="divide-y divide-gray-200 dark:divide-dark-400">
                    {filteredPosts.length === 0 ? (
                      <div className="p-8 text-center text-gray-500 dark:text-gray-400">
                        <FiImage className="w-12 h-12 mx-auto mb-2 opacity-30" />
                        <p>Planlanmış içerik bulunamadı</p>
                      </div>
                    ) : (
                      filteredPosts.map((post) => {
                        const IconComponent = getPlatformIcon(post.platform);
                        const account = accounts.find(acc => acc.id === post.accountId);
                        return (
                          <div key={post.id} className="p-4 hover:bg-gray-50 dark:hover:bg-dark-400 transition-colors">
                            <div className="flex items-start justify-between gap-4">
                              <div className="flex-1">
                                <div className="flex items-center gap-2 mb-2">
                                  <IconComponent className={`w-5 h-5 ${getPlatformColor(post.platform)}`} />
                                  <span className="font-semibold text-[#283252] dark:text-darkWhite-300">
                                    @{post.accountName}
                                  </span>
                                  <Chip
                                    size="sm"
                                    variant="flat"
                                    className={
                                      post.status === 'published'
                                        ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300'
                                        : 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300'
                                    }
                                  >
                                    {post.status === 'published' ? 'Yayınlandı' : 'Planlandı'}
                                  </Chip>
                                </div>
                                <p className="text-sm text-gray-700 dark:text-gray-300 mb-2 line-clamp-2">{post.content}</p>
                                <div className="flex items-center gap-4 text-xs text-gray-500 dark:text-gray-400">
                                  <span className="flex items-center gap-1">
                                    <FiCalendar className="w-3 h-3" />
                                    {post.scheduledDate}
                                  </span>
                                  {post.media !== 'none' && (
                                    <span className="flex items-center gap-1">
                                      <FiImage className="w-3 h-3" />
                                      Medya
                                    </span>
                                  )}
                                </div>
                              </div>
                              <div className="flex items-center gap-2">
                                <Button
                                  isIconOnly
                                  size="sm"
                                  variant="light"
                                  onPress={() => handleEditPost(post)}
                                >
                                  <FiEdit2 className="w-4 h-4" />
                                </Button>
                                <Button
                                  isIconOnly
                                  size="sm"
                                  variant="light"
                                  className="text-red-400"
                                  onPress={() => handleDeletePost(post.id)}
                                >
                                  <FiTrash2 className="w-4 h-4" />
                                </Button>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    )}
                  </div>
                </CardBody>
              </Card>
            </div>
          )}
        </div>

        {/* Hesap Ekleme Modal */}
        <Modal isOpen={isAccountModalOpen} onClose={() => setIsAccountModalOpen(false)} size="lg">
          <ModalContent>
            <ModalHeader>Yeni Hesap Ekle</ModalHeader>
            <ModalBody>
              <Select
                label="Platform"
                placeholder="Platform seçin"
                selectedKeys={accountForm.platform ? [accountForm.platform] : []}
                onSelectionChange={(keys) => {
                  const selected = Array.from(keys)[0];
                  setAccountForm({ ...accountForm, platform: selected || '' });
                }}
                classNames={{
                  trigger: "border border-gray-200 dark:border-dark-400"
                }}
              >
                {platformOptions.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    <div className="flex items-center gap-2">
                      <option.icon className="w-4 h-4" />
                      {option.label}
                    </div>
                  </SelectItem>
                ))}
              </Select>
              <Input
                label="Kullanıcı Adı / Sayfa Adı"
                placeholder="ör: heypena_official"
                value={accountForm.username}
                onChange={(e) => setAccountForm({ ...accountForm, username: e.target.value })}
                classNames={{
                  input: "border border-gray-200 dark:border-dark-400",
                  inputWrapper: "border border-gray-200 dark:border-dark-400"
                }}
              />
              <Input
                label="API Token / Access Token"
                placeholder="API token'ınızı girin"
                value={accountForm.accessToken}
                onChange={(e) => setAccountForm({ ...accountForm, accessToken: e.target.value })}
                classNames={{
                  input: "border border-gray-200 dark:border-dark-400",
                  inputWrapper: "border border-gray-200 dark:border-dark-400"
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button variant="light" onPress={() => setIsAccountModalOpen(false)}>
                İptal
              </Button>
              <Button className="bg-blue-600 text-white" onPress={handleSaveAccount}>
                Kaydet
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Yeni İçerik Modal */}
        <Modal isOpen={isPostModalOpen} onClose={() => setIsPostModalOpen(false)} size="lg">
          <ModalContent>
            <ModalHeader>Yeni İçerik Oluştur</ModalHeader>
            <ModalBody>
              <Select
                label="Hesap"
                placeholder="Hesap seçin"
                selectedKeys={postForm.accountId ? [postForm.accountId] : []}
                onSelectionChange={(keys) => {
                  const selected = Array.from(keys)[0];
                  setPostForm({ ...postForm, accountId: selected || '' });
                }}
                classNames={{
                  trigger: "border border-gray-200 dark:border-dark-400"
                }}
              >
                {accounts.map((account) => (
                  <SelectItem key={account.id.toString()} value={account.id.toString()}>
                    <div className="flex items-center gap-2">
                      {React.createElement(getPlatformIcon(account.platform), { className: "w-4 h-4" })}
                      @{account.username}
                    </div>
                  </SelectItem>
                ))}
              </Select>
              <Textarea
                label="İçerik"
                placeholder="İçeriğinizi yazın..."
                value={postForm.content}
                onChange={(e) => setPostForm({ ...postForm, content: e.target.value })}
                minRows={4}
                classNames={{
                  input: "border border-gray-200 dark:border-dark-400",
                  inputWrapper: "border border-gray-200 dark:border-dark-400"
                }}
              />
              <Input
                type="datetime-local"
                label="Planlanmış Tarih"
                value={postForm.scheduledDate}
                onChange={(e) => setPostForm({ ...postForm, scheduledDate: e.target.value })}
                classNames={{
                  input: "border border-gray-200 dark:border-dark-400",
                  inputWrapper: "border border-gray-200 dark:border-dark-400"
                }}
              />
              <Select
                label="Medya Tipi"
                selectedKeys={postForm.media ? [postForm.media] : []}
                onSelectionChange={(keys) => {
                  const selected = Array.from(keys)[0];
                  setPostForm({ ...postForm, media: selected || 'none' });
                }}
                classNames={{
                  trigger: "border border-gray-200 dark:border-dark-400"
                }}
              >
                <SelectItem key="none">Medya Yok</SelectItem>
                <SelectItem key="image">Resim</SelectItem>
                <SelectItem key="video">Video</SelectItem>
              </Select>
            </ModalBody>
            <ModalFooter>
              <Button variant="light" onPress={() => setIsPostModalOpen(false)}>
                İptal
              </Button>
              <Button className="bg-blue-600 text-white" onPress={handleSavePost}>
                Planla
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* İçerik Düzenleme Modal */}
        <Modal isOpen={isEditPostModalOpen} onClose={() => setIsEditPostModalOpen(false)} size="lg">
          <ModalContent>
            <ModalHeader>İçerik Düzenle</ModalHeader>
            <ModalBody>
              <Select
                label="Hesap"
                placeholder="Hesap seçin"
                selectedKeys={postForm.accountId ? [postForm.accountId] : []}
                onSelectionChange={(keys) => {
                  const selected = Array.from(keys)[0];
                  setPostForm({ ...postForm, accountId: selected || '' });
                }}
                classNames={{
                  trigger: "border border-gray-200 dark:border-dark-400"
                }}
              >
                {accounts.map((account) => (
                  <SelectItem key={account.id.toString()} value={account.id.toString()}>
                    <div className="flex items-center gap-2">
                      {React.createElement(getPlatformIcon(account.platform), { className: "w-4 h-4" })}
                      @{account.username}
                    </div>
                  </SelectItem>
                ))}
              </Select>
              <Textarea
                label="İçerik"
                placeholder="İçeriğinizi yazın..."
                value={postForm.content}
                onChange={(e) => setPostForm({ ...postForm, content: e.target.value })}
                minRows={4}
                classNames={{
                  input: "border border-gray-200 dark:border-dark-400",
                  inputWrapper: "border border-gray-200 dark:border-dark-400"
                }}
              />
              <Input
                type="datetime-local"
                label="Planlanmış Tarih"
                value={postForm.scheduledDate}
                onChange={(e) => setPostForm({ ...postForm, scheduledDate: e.target.value })}
                classNames={{
                  input: "border border-gray-200 dark:border-dark-400",
                  inputWrapper: "border border-gray-200 dark:border-dark-400"
                }}
              />
              <Select
                label="Medya Tipi"
                selectedKeys={postForm.media ? [postForm.media] : []}
                onSelectionChange={(keys) => {
                  const selected = Array.from(keys)[0];
                  setPostForm({ ...postForm, media: selected || 'none' });
                }}
                classNames={{
                  trigger: "border border-gray-200 dark:border-dark-400"
                }}
              >
                <SelectItem key="none">Medya Yok</SelectItem>
                <SelectItem key="image">Resim</SelectItem>
                <SelectItem key="video">Video</SelectItem>
              </Select>
            </ModalBody>
            <ModalFooter>
              <Button variant="light" onPress={() => setIsEditPostModalOpen(false)}>
                İptal
              </Button>
              <Button className="bg-blue-600 text-white" onPress={handleUpdatePost}>
                Güncelle
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </div>
    </div>
  );
}

